exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plugin-wrapper[data-v-50515570]{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;margin-bottom:1.25rem;position:relative}.plugin-wrapper .plugin-icon_title[data-v-50515570]{width:100%;text-align:center}.plugin-wrapper .plugin-icon_title .plugin-icon_title-text[data-v-50515570]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:100%;background-color:#fff;letter-spacing:.0625rem;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.75rem;line-height:1.66}", ""]);

// exports
